// extracted by mini-css-extract-plugin
export var figcaption = "card-module--figcaption--bry5u";
export var figure = "card-module--figure--bUqW2";
export var img = "card-module--img--+NBt0";
export var percent = "card-module--percent--m1Ddy";